import { render, staticRenderFns } from "./SignaturePage.vue?vue&type=template&id=a61194da"
import script from "./SignaturePage.vue?vue&type=script&lang=js"
export * from "./SignaturePage.vue?vue&type=script&lang=js"
import style0 from "./SignaturePage.vue?vue&type=style&index=0&id=a61194da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports